import { render, staticRenderFns } from "./RecuperarPasswordExito.vue?vue&type=template&id=bfefd584&scoped=true"
import script from "./RecuperarPasswordExito.vue?vue&type=script&lang=ts"
export * from "./RecuperarPasswordExito.vue?vue&type=script&lang=ts"
import style0 from "./RecuperarPasswordExito.vue?vue&type=style&index=0&id=bfefd584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfefd584",
  null
  
)

export default component.exports